<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-7">
				<sf-card class="p-0 h-100 card_bg">
					<clam-mst-search
						ref="clamMstSearch"
						:scrId="scrId"
						:pStartDt="pStartDt"
						:pEndDt="pEndDt"
						:pState1="pState1"
						:pState2="pState2"
						:pState3="pState3"
					/>
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 시작-->
			<div class="sf-col sf-col-17">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<clam-mst-table
						ref="table"
						@PopupClamMstNewOpen="PopupClamMstNewOpen"
						@PopupClamMstOpen="PopupClamMstOpen"
						@PopupRodetail="PopupRodetail"
						@Refresh="Refresh"
						:scrId="scrId"
					/>
					<clam-mst-popup ref="clamMstPopup" @Refresh="Refresh" :scrId="scrId" />

					<ro-apcn-popup ref="roApcnPopup" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import ClamMstSearch from './Search/ClamMstSearch.vue'; //클레임현황
import ClamMstTable from './Table/ClamMstTable.vue'; //클레임현황
import clamMstPopup from './ClamMstPopup/ClamMstPopup.vue'; //Ro 신청현황팝업
import RoApcnPopup from '@mqy/ceqi/RoApcn/Content/RoApcnPopup/RoApcnPopup.vue'; //PWA 신청현황팝업

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리상태값(승인,기각,반려,미결,처리완료,장기미결가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과값(승인,기각,반려,미결,처리완료,장기미결가져옴
		pState3: { type: String, default: '' } //클레임 승인현황에서 검색결과
	},
	components: { ClamMstSearch, ClamMstTable, clamMstPopup, RoApcnPopup },
	methods: {
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.clamMstSearch.searchList();
		},
		PopupClamMstNewOpen(param) {
			//this.userName = param.userName;
			//console.log('ContentView 에서의 param값 ::::: ', param);

			this.$refs.clamMstPopup.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		PopupClamMstOpen(param) {
			//alert('여기호출');

			this.$refs.clamMstPopup.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		PopupRodetail(param) {
			//alert('여기호출');

			this.$refs.roApcnPopup.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	}
};
</script>

<style></style>
